import React from "react";
import { Button } from "react-bootstrap";
import ShareDecorationPreview from "./ShareDecorationPreview";
import ShareTooltipPreview from "./ShareTooltipPreview";
import { DECORATIONS } from "./ShareCardDecorations";
import { TOOLTIP_SAMPLE } from "./ShareTooltip";

const PREVIEW_SCENE = { width: 1000, height: 1000 };
const PREVIEW_ELEMENTS = Object.fromEntries(DECORATIONS.map((preset) => [preset.id, {
  decoration: preset.id, width: 100, height: 100 / preset.aspect,
  x: 500, y: preset.type === "pin" ? 180 : 500, rotation: 0, textureSeed: 7,
}]));

export default function ShareGraphicsPanel({ onAddTooltip, onAddDecoration, onAddText, onImageUpload, imageInputRef, uploadsLoading, tooltipLoading, isExporting }) {
  return <>
    <section>
      <div className="share-editor-control-title">Panels</div>
      <button type="button" className="share-editor-graphic-preset" onClick={onAddTooltip} disabled={isExporting || tooltipLoading} aria-label="Add tooltip">
        <ShareTooltipPreview element={TOOLTIP_SAMPLE} />
        <span>{tooltipLoading ? "Adding tooltip…" : "Tooltip"}</span>
      </button>
    </section>
    <section>
      <div className="share-editor-control-title">Pins &amp; tape</div>
      <div className="share-editor-decoration-picker">
        {DECORATIONS.map((decoration) => <button type="button" key={decoration.id} onClick={() => onAddDecoration(decoration.id)} disabled={isExporting} aria-label={`Add ${decoration.label.toLowerCase()}`}>
          <ShareDecorationPreview element={PREVIEW_ELEMENTS[decoration.id]} scene={PREVIEW_SCENE} />
          <span>{decoration.label}</span>
        </button>)}
      </div>
    </section>
    <section>
      <div className="share-editor-control-title">Text &amp; images</div>
      <div className="d-grid gap-2">
        <Button variant="outline-primary" size="sm" disabled={isExporting} onClick={onAddText}>Add custom text</Button>
        <Button variant="outline-primary" size="sm" disabled={uploadsLoading || isExporting} onClick={() => imageInputRef.current?.click()}>{uploadsLoading ? "Adding images…" : "Add images"}</Button>
        <input ref={imageInputRef} type="file" accept="image/*" multiple hidden onChange={onImageUpload} aria-label="Add custom images" />
      </div>
    </section>
  </>;
}
